import { Component } from '@angular/core';

@Component({
  selector: 'app-spinner',
  standalone: false,

  templateUrl: './spinner.component.html'
})
export class SpinnerComponent {

}
